// extracted by mini-css-extract-plugin
export var bodyContainer = "dIj0u";
export var header = "eiX_N";